import React from 'react'
import { Field, Form, reduxForm } from 'redux-form/dist/redux-form'
import InputField from '@modules/formFields/InputField'
import { compose } from 'redux'
import { Trans, withTranslation } from 'react-i18next'
import SimpleModal from '@modules/admin/common/modal/simpleModal'
import './styles.scss'
const CompanyCreateModal = ({ handleSubmit, submitting, initialValues, t, onSubmit, hide }) => {
  return (
    <SimpleModal
      title={t('Crear Compañía')}
      hideModal={hide}
      loading={false}
      className="company-create-modal"
      template={
        <Form className="md-form full" onSubmit={handleSubmit(onSubmit)}>
          <Field name="name" component={InputField} placeholder={t('Nombre')} label={t('Nombre')} />
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            <Trans>Guardar</Trans>
          </button>
        </Form>
      }
    />
  )
}

const validate = (values, props) => {
  const { t } = props
  const errors = {}
  if (!values.name) {
    errors.name = t('Campo requerido')
  }
  return errors
}

export default compose(withTranslation(), reduxForm({ form: 'company', validate }))(CompanyCreateModal)
